/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import { Formik } from 'formik';
import { Box, Typography, Card, CardContent, Button as MuiButton } from '@material-ui/core';
import { useGlobal, Button } from '@rcg/ui-react';
import Loader from '../../components/Loader/index';
import Fields from './fields';
import useStyles from './index.style';
import validationSchema from './index.validation';
import Modal from '../../components/SignInModal';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-x_blue.svg';
import Dictionary from '../../commons/dictionary';
import useDictionary from '../../hooks/useDictionary';
import { getCookies, getSessionStorageItem } from '../../commons/utils';
import { COOKIE_KEYS, SESSION_STORAGE_GUEST_ACCOUNT_CREATION } from '../../commons/constants';
import { sendTrackingParams, trackPageView } from '../../commons/tracking/tracking';
import { useGlobalLogin } from '../../providers/GlobalLoginProvider';

const FormLogin = (reservation) => {
  const classes = useStyles();
  const {
    renderContent,
    data: { localizedDayjs },
  } = useGlobal();
  const getDictionaryValue = useDictionary(Dictionary);
  const { closeSignIn } = useGlobalLogin();

  const isSignIn = getCookies(COOKIE_KEYS.ACCESS_TOKEN);

  const { lastName, rsvNumber, sailDate, ship } = reservation?.tokenData || {};

  const [loginModal, setLoginModal] = useState(false);
  const [liteProfileLoading, setLiteProfileLoading] = useState(false);
  const { hideSubmitButton } = reservation;

  const values = {
    lastName: lastName || '',
    rsvNumber: rsvNumber || '',
    sailDate: sailDate || new Date(),
    ship: ship || '',
  };

  const handleSignInClick = () => {
    setLoginModal(true);
    sendTrackingParams(
      {
        eventType: 'interaction',
        interaction: `signIn:authentication:clicked`,
      },
      false,
    );
  };

  const handleCloseModal = () => {
    setLoginModal(false);
    closeSignIn();
    sendTrackingParams(
      {
        eventType: 'interactions',
        interaction: `myres:login:close`,
      },
      false,
    );
  };

  useEffect(() => {
    const guestAccountCreationTime =
      getSessionStorageItem(SESSION_STORAGE_GUEST_ACCOUNT_CREATION) || null;
    if (guestAccountCreationTime) {
      const fomatedIsoDate = guestAccountCreationTime?.replace(
        /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
        '$1-$2-$3T$4:$5:$6Z',
      );
      const gaCreated = new Date(fomatedIsoDate); // get client GMT time
      const currentTime = localizedDayjs();
      const timeFromCreation = currentTime.diff(gaCreated);
      const isNewGuestAccount = timeFromCreation <= 20000;

      if (isNewGuestAccount) {
        trackPageView({ isGALoggedIn: true });
        reservation.setNotification({
          title: getDictionaryValue(Dictionary.bookingAmendNotificationNewGuestAccountTitle.key),
          description: getDictionaryValue(
            Dictionary.bookingAmendNotificationNewGuestAccountMessage.key,
          ),
          open: true,
          type: 'success',
        });
      }
    }
  }, []);

  return (
    <Container
      maxWidth="sm"
      className={[classes.layout, hideSubmitButton ? 'hideSubmitButton' : ''].join(' ')}>
      <Loader
        display={liteProfileLoading}
        message={getDictionaryValue(Dictionary.amendRetrievePageLoaderMessage.key)}
      />
      <Typography variant="h1" className="form__title">
        {isSignIn
          ? reservation.formTitle
          : getDictionaryValue(Dictionary.bookingAmendFormLoginLogedTitle.key)}
      </Typography>
      {!isSignIn && (
        <>
          <Card className={classes.siginCard}>
            <CardContent className="card-content">
              <div className="description">
                {getDictionaryValue(Dictionary.bookingAmendFormLoginSigOutTitle.key)}
              </div>
              <Button variant="contained" color="primary" onClick={handleSignInClick}>
                {getDictionaryValue(Dictionary.bookingAmendFormLoginSigInCta.key)}
              </Button>
            </CardContent>
          </Card>
          <Typography className="form__subTitle" gutterBottom>
            {getDictionaryValue(Dictionary.bookingAmendFormLoginUnLoggedDescription.key)}
          </Typography>
        </>
      )}
      <Modal
        closeModal={handleCloseModal}
        setLoginModal={setLoginModal}
        open={loginModal}
        setLiteProfileLoading={setLiteProfileLoading}
        setGuestName={reservation.setGuestName}
        setTriggerGuestProfile={reservation?.setTriggerGuestProfile}>
        <Box className={classes.modalContainer}>
          <MuiButton variant="text" onClick={handleCloseModal} disableTouchRipple>
            <CloseIcon />
          </MuiButton>
        </Box>
      </Modal>
      {reservation.formDescription ? (
        <Typography className="form__subTitle" gutterBottom>
          {reservation.formDescription}
        </Typography>
      ) : (
        <Typography className="form__subTitle" gutterBottom>
          {isSignIn && reservation.isProfileDataEmpty ? (
            <>
              <strong className="emptyBookingStrong">
                {getDictionaryValue(Dictionary.bookingAmendLookUpSubtitleNoBookings.key)}
              </strong>
              <span className="spacer" />
              <span className="emptyBookingRegular">
                {getDictionaryValue(Dictionary.bookingAmendLookUpDescriptionNoBookings.key)}
              </span>
            </>
          ) : (
            isSignIn && (
              <>
                <span className="withoutGAP">
                  {getDictionaryValue(Dictionary.formBookingAmendSectionDescription.key)}
                </span>
                <strong className="withoutGAP">
                  {getDictionaryValue(Dictionary.formBookingAmendSectionDescriptionSecond.key)}
                </strong>
                <span className="withoutGAP">
                  {getDictionaryValue(Dictionary.formBookingAmendSectionDescriptionThird.key)}
                </span>
              </>
            )
          )}
        </Typography>
      )}
      <Formik
        enableReinitialize={reservation.reinitializeForm}
        initialValues={values}
        validationSchema={validationSchema(renderContent)}>
        {(props) => <Fields {...{ ...props, ...reservation }} />}
      </Formik>
    </Container>
  );
};

export default FormLogin;
